import {
  IPairingPosition,
  isIPairingPosition,
  IUser,
  IWebsocketUpdatedCrewschedPlannedEvent,
  WebsocketMessageType,
} from "@vmosolutions/oc-interfaces";

import { ThunkAction, ThunkDispatch } from "redux-thunk";

import { IRootState } from "../../reducers/CombinedReducers";

import { AnyAction } from "redux";

import {
  CrewSchedEvent,
  findOverlappingIndex,
  ICrewSchedEventMap,
  isIDisplayPairing,
  newCrewPlannedEvent,
} from "../../reducers/CrewScheduleReducer";

import { Type } from "./CrewSchedule.Actions";

/**
 * use a websocket action with Thunk to update the redux store
 * for planned events (IDisplayPairing | INonFlyingAssignment)
 * @param updatedEvent -
 * @param actionType -
 */
export const webSocketUpdatePlannedPairingEvent = (
  updatedEvent: IWebsocketUpdatedCrewschedPlannedEvent,
  actionType: WebsocketMessageType
): ThunkAction<void, IRootState, object, AnyAction> => {
  return (dispatch: ThunkDispatch<IRootState, object, AnyAction>, getState: () => IRootState): void => {
    // no update, nothing to do
    if (!updatedEvent) return;
    const { oldEvent, newEvent } = updatedEvent;

    const crewPlannedEvents: ICrewSchedEventMap = { ...getState().crewSchedule.crewPlannedEvents };

    const lastModified = Date.now();
    const newCrewMembers = newEvent ? (isIDisplayPairing(newEvent) ? newEvent.positions : newEvent.crew) : [];
    const positions: (IPairingPosition | IUser)[] = oldEvent
      ? isIDisplayPairing(oldEvent)
        ? oldEvent.positions
        : oldEvent.crew
      : [];

    newCrewMembers.forEach((value: IPairingPosition | IUser) => {
      const id = isIPairingPosition(value) ? value.crew_id : value._id;
      if (
        positions.findIndex((pos: IPairingPosition | IUser) =>
          isIPairingPosition(pos) ? pos.crew_id === id : pos._id === id
        ) < 0
      ) {
        positions.push(value);
      }
    });
    positions.forEach((eventCrew: IPairingPosition | IUser) => {
      const crewId = isIPairingPosition(eventCrew) ? eventCrew.crew_id : eventCrew._id;
      if (!crewPlannedEvents[crewId]) {
        crewPlannedEvents[crewId] = newCrewPlannedEvent(lastModified);
      }
      const crewMemberPlannedEvents = crewPlannedEvents[crewId];
      crewMemberPlannedEvents.lastModified = lastModified;
      const overlappingPlannedEvents = [...crewMemberPlannedEvents.plannedEvents];
      const [oldGroupIndex, oldEventIndex] = findPlannedEventsFromCrewMap(overlappingPlannedEvents, oldEvent);

      if (oldGroupIndex >= 0 && oldEventIndex >= 0) {
        const crewInNewPlannedEventIndex = newCrewMembers.findIndex((newEventCrew: IPairingPosition | IUser) => {
          const id = isIPairingPosition(newEventCrew) ? newEventCrew.crew_id : newEventCrew._id;
          return id === crewId;
        });
        if (newEvent && crewInNewPlannedEventIndex >= 0) {
          overlappingPlannedEvents[oldGroupIndex][oldEventIndex] = newEvent;
          overlappingPlannedEvents[oldGroupIndex].sort(
            (a: CrewSchedEvent, b: CrewSchedEvent) => a?.start?.valueOf() - b?.start?.valueOf()
          );
        } else {
          overlappingPlannedEvents[oldGroupIndex].splice(oldEventIndex, 1);
          if (overlappingPlannedEvents[oldGroupIndex].length < 1) {
            //sometimes overlappingPlannedEvents[oldGroupIndex] is []
            overlappingPlannedEvents.splice(oldGroupIndex, 1);
          }
        }
      } else {
        if (newEvent) {
          const foundOverlapIndex = findOverlappingIndex(overlappingPlannedEvents, newEvent);
          if (foundOverlapIndex >= 0) {
            overlappingPlannedEvents[foundOverlapIndex].push(newEvent);
            overlappingPlannedEvents[foundOverlapIndex].sort(
              (a: CrewSchedEvent, b: CrewSchedEvent) => a?.start?.valueOf() - b?.start?.valueOf()
            );
          } else {
            overlappingPlannedEvents.push([newEvent]);
          }
        }
      }
      overlappingPlannedEvents.sort(
        (a: CrewSchedEvent[], b: CrewSchedEvent[]) => a[0]?.start?.valueOf() - b[0]?.start?.valueOf()
      );
      crewMemberPlannedEvents.plannedEvents = overlappingPlannedEvents;
    });

    dispatch({
      type: Type.UPDATE_PLANNED_EVENTS,
      crewPlannedEvents,
    });
  };
};

export const findPlannedEventsFromCrewMap = (
  crewPlannedEvents: CrewSchedEvent[][],
  oldEvent: CrewSchedEvent
): [number, number] => {
  let eventIndex = -1;
  const groupIndex = crewPlannedEvents.findIndex((eventGroup: CrewSchedEvent[], index: number) => {
    const foundIndex = eventGroup.findIndex(findEvent(oldEvent?._id));
    if (foundIndex < 0) {
      return false;
    }
    eventIndex = foundIndex;
    return true;
  });

  return [groupIndex, eventIndex];
};

const findEvent = (id: string) => (event: CrewSchedEvent) => event?._id === id;
